import { SvgIcon, SxProps, Theme } from "@mui/material";
import React, { FunctionComponent } from "react";
import { Icon, IconProps } from "@iconify/react";

export const IcIcon: FunctionComponent<
  IconProps & { noWrap?: boolean } & { sx?: SxProps<Theme> }
> = (props) => {
  const { noWrap, sx, ...otherProps } = props;
  if (noWrap) {
    return <Icon {...otherProps} />;
  }
  return (
    <SvgIcon sx={sx}>
      <Icon {...otherProps} />
    </SvgIcon>
  );
};
export default IcIcon;
